<div appModal (closeModal)="close()" [mainClass]="'lg-modal'">
  <section class="modal-title-container">
    <div class="modal--title">Contact</div>
  </section>

  <section class="modal-content-container">
    <div class="py-10 contact-item" *ngFor="let contact of contactsList">
      <div class="flex flex-wrap">
        <img *ngIf="contact.avatar" [src]="contact.avatar" alt="" class="avatar" />
        <div *ngIf="!contact.avatar" class="avatar flex items-center justify-center bg-veryLtGrey text-grey">
          <svg-icon [src]="defaultAvatar"></svg-icon>
        </div>
        <div class="contact-data flex flex-col justify-center leading-normal ml-20">
          <p>{{ contact.name }}</p>
          <p>{{ contact.details }}</p>
          <p>{{ contact.email }}</p>
          <p>{{ contact.phone }}</p>
        </div>
        <div class="break-mobile hide-lg-up"></div>
        <div *ngIf="contact.email" class="flex items-center ml-auto">
          <button class="btn btn-lg" (click)="copyEmail(contact)">Copy email</button>
        </div>
      </div>
    </div>
  </section>
  <div class="textarea-container" #emailCopyContainer></div>

  <section class="modal-actions-container">
    <button class="btn btn-grey btn-lg" (click)="close()">Close</button>
  </section>
</div>
fcemail@nextpro.com
